import actionTypes from 'SRC/modules/redux/actionTypes'

export const setFormResult = result => ({
  type: actionTypes.SET_FORM_RESULT,
  payload: result
})
